export default {"src":"/_next/static/media/arrow-right.da4a6b22.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};